import axios from 'axios';
import { MetaData } from 'statue-helpers';

const API_URL = process.env.REACT_APP_API_URL || '';

export const getAllMetadata = async () => {
  const res = await axios.get<Array<Exclude<MetaData, 'attributes'>>>(
    API_URL + 'statues'
  );
  const metadata = await res.data;
  return metadata;
};

export const getMetadata = async (url: string) => {
  const res = await axios.get<MetaData>(url);
  const metadata = await res.data;
  return metadata;
};

export const getPendingRendersDna = async (ownerAddress: string) => {
  const res = await axios.get<string[]>(
    API_URL + 'renderer/pending/' + ownerAddress
  );
  const dnas = await res.data;
  return dnas;
};
